function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangflowLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M416.8 268.4H487c13.8 0 25 11.2 25 25v41.5c0 13.8-11.2 25-25 25h-61.3c-6.6 0-13 2.6-17.7 7.3L302.9 472.3c-4.7 4.7-11 7.3-17.7 7.3h-50.6c-13.5 0-24.6-10.8-25-24.3l-1.1-42.3c-.4-14 10.9-25.6 25-25.6H277c6.6 0 13-2.6 17.7-7.3L399 275.8c4.8-4.7 11.1-7.4 17.8-7.4",
    style: {
      fill: "#782cf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.1 32.4h70.3c13.8 0 25 11.2 25 25v41.5c0 13.8-11.2 25-25 25h-61.3c-6.6 0-13 2.6-17.7 7.3L94.3 236.3c-4.7 4.7-11 7.3-17.7 7.3H26.1c-13.5 0-24.6-10.8-25-24.3L0 177c-.4-14 10.9-25.6 25-25.6h43.5c6.6 0 13-2.6 17.7-7.3L190.4 39.7c4.7-4.6 11.1-7.3 17.7-7.3",
    style: {
      fill: "#f54478"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.8 85.8H487c13.8 0 25 11.2 25 25v41.5c0 13.8-11.2 25-25 25h-61.3c-6.6 0-13 2.6-17.7 7.3L302.9 289.7c-4.7 4.7-11 7.3-17.7 7.3h-61.4c-6.4 0-12.6 2.5-17.3 6.9l-118 113.2c-4.6 4.5-10.8 6.9-17.3 6.9h-43c-13.8 0-25-11.2-25-25v-42.6c0-13.8 11.2-25 25-25h42.7c6.6 0 13-2.6 17.7-7.3L200.7 212c4.7-4.7 11-7.3 17.7-7.3h58.8c6.6 0 13-2.6 17.7-7.3L399.1 93.1c4.7-4.6 11-7.3 17.7-7.3",
    style: {
      fill: "#ef85fd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangflowLogo);
export default __webpack_public_path__ + "static/media/langflow-logo.0c190e38f13aa91d068056551d92f3e3.svg";
export { ForwardRef as ReactComponent };